var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 398.44 689.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: Monaco, Monaco;\n        font-size: 8px;\n        letter-spacing: -.02em;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #435d78;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #435d78;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "back"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.24,378.42H39.27V51.03h249.97v327.39ZM40.07,377.62h248.37V51.83H40.07v325.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "293.5 53.83 292.08 53.83 292.08 47.97 36.61 47.97 36.61 53.83 35.2 53.83 35.2 46.98 293.5 46.98 293.5 53.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.24,402.61H39.27v-51.69h249.97v51.69ZM40.07,401.81h248.37v-50.09H40.07v50.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.24,351.68H39.27v-11.48h249.97v11.48ZM40.07,350.88h248.37v-9.88H40.07v9.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.07,689.65h-17.05v-374.11h17.05v374.11ZM23.82,688.85h15.45v-372.51h-15.45v372.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M305.36,689.65h-17.05v-374.11h17.05v374.11ZM289.11,688.85h15.45v-372.51h-15.45v372.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.07,689.65H0v-8.92h40.07v8.92ZM.8,688.85h38.47v-7.33H.8v7.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M328.19,689.65h-40.07v-8.92h40.07v8.92ZM288.92,688.85h38.47v-7.33h-38.47v7.33Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.09,238.74c-9.81,0-17.78-7.98-17.78-17.78s7.98-17.78,17.78-17.78,17.78,7.98,17.78,17.78-7.98,17.78-17.78,17.78ZM164.09,203.98c-9.36,0-16.98,7.62-16.98,16.98s7.62,16.98,16.98,16.98,16.98-7.62,16.98-16.98-7.62-16.98-16.98-16.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.28,245.28h-38.36c-2.84,0-5.14-2.31-5.14-5.14v-38.36c0-2.84,2.31-5.14,5.14-5.14h38.36c2.84,0,5.14,2.31,5.14,5.14v38.36c0,2.84-2.31,5.14-5.14,5.14ZM144.91,197.44c-2.39,0-4.34,1.95-4.34,4.34v38.36c0,2.39,1.95,4.34,4.34,4.34h38.36c2.39,0,4.34-1.95,4.34-4.34v-38.36c0-2.39-1.95-4.34-4.34-4.34h-38.36Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 146.93,
    cy: 204,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 181.48,
    cy: 204,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 146.93,
    cy: 238.34,
    r: 2.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 181.48,
    cy: 238.34,
    r: 2.98
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.49,77.56h-14.79v-26.53h14.79v26.53ZM157.5,76.76h13.19v-24.93h-13.19v24.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 162.58,
    y: 60.91,
    width: 3.03,
    height: 10.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 60,
    y: 40.6,
    width: 71.77,
    height: 6.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 51.87,
    y: 315.94,
    width: 224.79,
    height: 3.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 39.67,
    y: 299.17,
    width: 248.85,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.98,
    y: 301.17,
    width: 4.74,
    height: 14.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 243.82,
    y: 301.17,
    width: 4.74,
    height: 14.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 140.34,
    y: 318.98,
    width: 47.85,
    height: 21.63
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.12,265.55h-.8v-6.21h.8v6.21ZM86.12,251.34h-.8v-7.99h.8v7.99ZM86.12,235.36h-.8v-7.99h.8v7.99ZM86.12,219.37h-.8v-7.99h.8v7.99ZM86.12,203.38h-.8v-7.99h.8v7.99ZM86.12,187.4h-.8v-7.99h.8v7.99ZM86.12,171.41h-.8v-7.99h.8v7.99ZM86.12,155.42h-.8v-7.99h.8v7.99ZM86.12,139.43h-.8v-7.99h.8v7.99ZM86.12,123.45h-.8v-7.99h.8v7.99ZM86.12,107.46h-.8v-7.99h.8v7.99ZM86.12,91.47h-.8v-7.99h.8v7.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82.46 262.9 83.04 262.36 85.72 265.24 88.41 262.36 88.99 262.9 85.72 266.42 82.46 262.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M244.22,265.55h-.8v-6.21h.8v6.21ZM244.22,251.34h-.8v-7.99h.8v7.99ZM244.22,235.36h-.8v-7.99h.8v7.99ZM244.22,219.37h-.8v-7.99h.8v7.99ZM244.22,203.38h-.8v-7.99h.8v7.99ZM244.22,187.4h-.8v-7.99h.8v7.99ZM244.22,171.41h-.8v-7.99h.8v7.99ZM244.22,155.42h-.8v-7.99h.8v7.99ZM244.22,139.43h-.8v-7.99h.8v7.99ZM244.22,123.45h-.8v-7.99h.8v7.99ZM244.22,107.46h-.8v-7.99h.8v7.99ZM244.22,91.47h-.8v-7.99h.8v7.99Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "240.56 262.9 241.14 262.36 243.82 265.24 246.51 262.36 247.09 262.9 243.82 266.42 240.56 262.9"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 35.7,
    y1: 16.07,
    x2: 293,
    y2: 16.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.2,
    y: 12.82,
    width: 1,
    height: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 292.5,
    y: 12.82,
    width: 1,
    height: 6.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 389.56,
    y1: 41.1,
    x2: 389.56,
    y2: 689.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 386.31,
    y: 40.6,
    width: 6.5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 386.31,
    y: 688.65,
    width: 6.5,
    height: 1
  }))), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(384.36 35.27)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "63\u2019")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(158.08 7.03)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "24\u2019"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueprint);
export default __webpack_public_path__ + "static/media/blueprint.1207aa96c02404aa2f081cdd38caf095.svg";
export { ForwardRef as ReactComponent };